import { Multiplesample } from "@/lib/types";
import { AdvancedSearchConfig, attachmentPhotoAdvancedSearchGroup } from "../forms/advanced-search/advanced-search-fields-def";
import { artistLastNameSortGroup } from "../forms/advanced-search/artist-sort-fields";
import { ColumnFormatted } from "./general";

export const exemplairesColumns: ColumnFormatted<Multiplesample>[] = [
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionNumeroEnregistrement",
    visible: true,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionNumero",
    visible: true,
  },
  { type: "image", key: "vignette", visible: true },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionNumeroInventaire",
    visible: true,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionLocalisation",
    visible: true,
  },
  {
    type: "richtext",
    key: "exemplaireDansEstampesMultiplesDescriptionNotes",
    visible: true,
  },
  {
    type: "status",
    key: "exemplaireDansEstampesMultiplesDescriptionStatus",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesStatus",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionAncienNumero",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionAutreNumero",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionType",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionPrinter",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionEditor",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesMultiplesDescriptionDateTirage",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesTechnique",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesSupport",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesEditionNumber",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesSignatureInscription",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesInscriptionDos",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesEstimationDescription",
    visible: false,
  },
  {
    type: "currency",
    key: "exemplaireDansEstampesEstimationAmount",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesSaleDescription",
    visible: false,
  },
  {
    type: "currency",
    key: "exemplaireDansEstampesSaleAmount",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesAcquisitionDescription",
    visible: false,
  },
  {
    type: "currency",
    key: "exemplaireDansEstampesAcquisitionAmount",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesStorageLocation2",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesStorageLocation3",
    visible: false,
  },
  {
    type: "dimensions",
    key: "exemplaireDansEstampesDimensions",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsVerifiees",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsInconnues",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsDouteuses",
    visible: false,
  },
  {
    type: "dimensions",
    key: "exemplaireDansEstampesDimensionsImage",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsImageVerifiees",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsImageInconnues",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsImageDouteuses",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesDimensionsPoids",
    visible: false,
  },
  {
    type: "string",
    key: "exemplaireDansEstampesDimensionsRaw",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesDimensionsIsProfondeur",
    visible: false,
  },
  {
    type: "richtext",
    key: "exemplaireDansEstampesMultiplesDescriptionNotesTechniques",
    visible: false,
  },
  {
    type: "richtext",
    key: "exemplaireDansEstampesMultiplesDescriptionNotesConditions",
    visible: false,
  },
  {
    type: "multilingual",
    key: "exemplaireDansEstampesMultiplesRemarquesPubliquesMultilingual",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesMultiplesRemarquesPubliquesPublished",
    visible: false,
  },
  {
    type: "boolean",
    key: "exemplaireDansEstampesMultiplesOeuvreNonLocalisee",
    visible: false,
  },
];

export const exemplairesColumnsVisibility = exemplairesColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible || false,
  }),
  {},
);

export const exemplairesAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "exemplaires",
    fields: [
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNumeroEnregistrement",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNumero",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNumeroInventaire",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesMultiplesDescriptionNumeroInventairePubli",
        label:
          "exemplaireDansEstampesMultiplesDescriptionNumeroInventairePublished",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNotes",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionStatus",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesStatus",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionAncienNumero",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesMultiplesDescriptionAncienPublished",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionAutreNumero",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesMultiplesDescriptionAutrePublished",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionType",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionPrinter",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionEditor",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionDateTirage",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesTechnique",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesSupport",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesEditionNumber",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesSignatureInscription",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesInscriptionDos",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesInscriptionDosPublished",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesEstimationDescription",
      },
      {
        type: "currency",
        key: "exemplaireDansEstampesEstimationAmount",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesSaleDescription",
      },
      {
        type: "currency",
        key: "exemplaireDansEstampesSaleAmount",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesAcquisitionDescription",
      },
      {
        type: "currency",
        key: "exemplaireDansEstampesAcquisitionAmount",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionLocalisation",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesStorageLocation2",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesStorageLocation3",
      },
      {
        type: "dimensions",
        key: "exemplaireDansEstampesDimensions",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsVerifiees",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsInconnues",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsDouteuses",
      },
      {
        type: "dimensions",
        key: "exemplaireDansEstampesDimensionsImage",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsImageVerifiees",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsImageInconnues",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsImageDouteuses",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesDimensionsPoids",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesDimensionsRaw",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesDimensionsIsProfondeur",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNotesTechniques",
      },
      {
        type: "string",
        key: "exemplaireDansEstampesMultiplesDescriptionNotesConditions",
      },
      {
        type: "multilingual",
        key: "exemplaireDansEstampesMultiplesRemarquesPubliquesMultilingual",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesMultiplesRemarquesPubliquesPublished",
      },
      {
        type: "boolean",
        key: "exemplaireDansEstampesMultiplesOeuvreNonLocalisee",
      },
    ],
  },
  artistLastNameSortGroup(),
  attachmentPhotoAdvancedSearchGroup,
];
